export const PurchasesEndpoints = {
    incomingInvoices: () => '/purchases/incoming-invoices',
    draftInvoices: () => '/purchases/draft-invoices',
    draftInvoice: (id: string) => `/purchases/draft-invoices/${id}`,
    importPurchase: () => '/purchases/import',
    importHistory: () => '/purchases/import-history',
    receivedInvoices: () => '/purchases/received-invoices',
    summary: () => '/purchases/summary',
};
